import { useState } from 'react'

export function useSelectShowSelected({ value }) {
  const [showSelected, setShowSelected] = useState(false)
  const [prevValue, setPrevValue] = useState(value)

  // Hide the selected view when the value empties — during render.
  if (value !== prevValue) {
    setPrevValue(value)

    if ((Array.isArray(value) && value.length === 0) || !value) {
      setShowSelected(false)
    }
  }

  function handleToggleShowSelected() {
    setShowSelected(prevShowSelected => !prevShowSelected)
  }

  function handleShowSelected() {
    setShowSelected(true)
  }

  function handleHideSelected() {
    setShowSelected(false)
  }

  return {
    handleHideSelected,
    handleShowSelected,
    handleToggleShowSelected,
    setShowSelected,
    showSelected,
  }
}
